import {context} from 'vue3-starter/src/typescript/app-context/AppContext';

export class TrackingRepository {
    async track(eventName: string, properties = {}): Promise<void> {
        if (!context.registry.entries['track']) {
            console.error('Should register track hateoas link');
            return;
        }

        context.httpService.post(context.registry.entries.track(), {
            name: eventName.toLowerCase(),
            properties,
        });
    }
}
